import { TIME_UNIT_IN_MILLISECONDS } from 'app-constants';
import { TimeUnit } from 'types';

interface GetTimeIntervalByUnitArgs {
    interval: number;
    unit: TimeUnit;
}

export default function getTimeIntervalByUnit({
    interval,
    unit,
}: GetTimeIntervalByUnitArgs): string {
    return new Date(
        Date.now() + interval * TIME_UNIT_IN_MILLISECONDS[unit]
    ).toISOString();
}
